import { Link } from 'react-router-dom';
import { PageContainer } from '../../components/PageContainer';

export const AdminContent = () => {
  return (
    <PageContainer>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Content Management</h1>
          <p className="text-gray-600 mt-2">
            Manage wineries, wines, and events. Review and approve user-submitted content, edit existing entries, and maintain the quality of platform content.
          </p>
        </div>

        {/* Venue Management Section */}
        <section className="bg-gray-50 rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Venue Management</h2>
          <div className="space-y-3">
            <Link
              to="/admin/venues/create"
              className="inline-flex items-center px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 transition-colors"
            >
              Create New Venue
            </Link>
            <p className="text-sm text-gray-600">
              Add new wineries, tasting rooms, wine bars, and other venues to the platform.
            </p>
          </div>
        </section>

        {/* Placeholder sections for future content */}
        <section className="bg-gray-50 rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Wine Management</h2>
          <p className="text-gray-600">Wine management features coming soon.</p>
        </section>

        <section className="bg-gray-50 rounded-lg border border-gray-200 p-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Event Management</h2>
          <p className="text-gray-600">Event management features coming soon.</p>
        </section>
      </div>
    </PageContainer>
  );
};
